import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

type DeleteAccountButtonProps = {
  onDelete: () => void;
};

const DeleteAccountButton = ({ onDelete }: DeleteAccountButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className='mt-6 flex flex-col items-end pb-4'>
      <button
        type='button'
        className='inline-flex items-center gap-1 text-[12px] font-medium text-[#6B7280] transition-colors hover:text-[#0E0E0B]'
        aria-expanded={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        More options
        <ChevronDown
          size={14}
          className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
          aria-hidden='true'
        />
      </button>
      {isOpen && (
        <button
          type='button'
          className='mt-3 rounded-[10px] bg-[#DC2626] px-5 py-2 text-[12px] font-semibold text-white transition-colors hover:bg-[#B91C1C]'
          onClick={onDelete}
        >
          Delete account
        </button>
      )}
    </div>
  );
};

export default DeleteAccountButton;
